import { EquipmentState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const equipmentState: EquipmentState = {
  Equipments: [],
  Terminals: [],
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
  totalRecordCount: 0,
  name: '',
  terminalId: undefined,
  assetType: undefined,
  createUpdateEquipmentModal: false,
  selectedEquipmentId: undefined,
  visibilitySets: [],
  dvirForms: [],
  products: [],
  accountProperties: [],
  exportModal: false,
  csvExportModalOpen: false,
  visibilitySetsModalOpen: false,
  eldEnabled: false,
  isUseGpsOdometerEnabled: false,
  isUseManualEngineHoursEnabled: false,
  isDuplicateVinEnabled: false,
  canActivateCalAmpDevice: false,
  showMonthlyChanges: false,
  createUpdateModal: {
    method: 'create',
    visible: false,
    selectedEquipmentId: undefined,
    canEdit: false,
  },
  columns: [
    {
      id: 'type',
      field: 'type',
      header: 'Type',
      order: 0,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'name',
      field: 'name',
      header: 'Name',
      order: 1,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'terminal',
      field: 'terminal',
      header: 'Terminal',
      order: 2,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'regulationMode',
      field: 'regulationMode',
      header: 'Regulation Mode',
      order: 1,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'vbusDevice',
      field: 'vbusDevice',
      header: 'Vbus Device',
      order: 2,
      isVisible: true,
      option: { width: '160px', sortBy: 'event-type' },
    },
    {
      id: 'active',
      field: 'active',
      header: 'Active',
      order: 3,
      isVisible: true,
      option: { width: '160px' },
    },
    {
      id: 'action',
      field: 'action',
      header: 'Action',
      order: 4,
      isVisible: true,
      option: { width: '100px' },
    },
  ],
};
